import { Typography } from "antd";
import React from "react";

const NoPermission = () => {
  return (
    <Typography.Paragraph>
      You currently do not have the permission to view any liftoff systems. Please check with na_opsenablement@credera.com to make sure
      your permissions are configured correctly.
    </Typography.Paragraph>
  );
}

export { NoPermission };